import React from "react";

import type { LegalSection } from "./legal.types";
import LegalPageLayout from "./LegalPageLayout";

const intro = ["p1", "p2"] as const;

/** Section order and shape; the prose lives under `privacyPolicy` in the legal namespace. */
const sections: LegalSection[] = [
	{ key: "informationWeCollect", listItems: ["i1", "i2", "i3", "i4", "i5", "i6", "i7", "i8"], paragraphs: ["p1"] },
	{ key: "howWeUseYourInformation", listItems: ["i1", "i2", "i3", "i4", "i5", "i6", "i7"], paragraphs: ["p1"] },
	{
		key: "legalBases",
		listItems: ["i1", "i2", "i3", "i4"],
		paragraphs: ["p1"],
		trailingParagraphs: ["p1", "p2"]
	},
	{ key: "userGeneratedContent", paragraphs: ["p1", "p2", "p3", "p4"] },
	{ key: "peopleInTrees", paragraphs: ["p1", "p2"] },
	{ key: "publicContentAndSharing", paragraphs: ["p1", "p2", "p3"] },
	{ key: "cookies", paragraphs: ["p1"] },
	{ key: "thirdPartyServices", listItems: ["i1", "i2", "i3", "i4", "i5", "i6", "i7"], paragraphs: ["p1"] },
	{ key: "internationalTransfers", paragraphs: ["p1", "p2"] },
	{
		key: "dataRetention",
		listItems: ["i1", "i2", "i3", "i4", "i5", "i6", "i7", "i8", "i9", "i10", "i11", "i12", "i13", "i14"],
		paragraphs: ["p1"]
	},
	{
		key: "yourRights",
		listItems: ["i1", "i2", "i3", "i4", "i5", "i6", "i7"],
		paragraphs: ["p1"],
		trailingParagraphs: ["p1"]
	},
	{ key: "security", paragraphs: ["p1"] },
	{ key: "childrensPrivacy", paragraphs: ["p1"] },
	{ key: "changesToPolicy", paragraphs: ["p1"] },
	{ key: "governingLaw", paragraphs: ["p1", "p2"] },
	{ key: "contactUs", paragraphs: ["p1"] }
];

const PrivacyPolicyPage = () => {
	return <LegalPageLayout intro={intro} page="privacyPolicy" sections={sections} />;
};

export default PrivacyPolicyPage;
